customElements.define(
  'sticky-product-form',
  class StickyProductForm extends HTMLElement {
    formActiveClassName = 'product-sticky-form--active'
    formInactiveClassName = 'product-sticky-form--inactive'
    documentBody = document.querySelector('body')
    windowWidth = 0

    constructor() {
      super();
    }

    isMobile() {
      return window.innerWidth <= 767
    }


    connectedCallback() {
      this.productForm = document.querySelector(`${this.isMobile() ? '.product__info-wrapper' : ''} product-form`);

      this.productFormBounds = {};

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', () => {
        if (this.windowWidth !== window.innerWidth) {
          this.windowWidth = window.innerWidth;

          this.addAdditionalSpace()
        }
      });

      this.createObserver();
      this.addAdditionalSpace();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.productFormBounds = entries[0].isIntersecting;
      });
      observer.observe(this.productForm);
    }

    onScroll() {
      this.productFormBounds || (this.isMobile() && this.productForm.getBoundingClientRect().y > 0)
        ? requestAnimationFrame(this.hide.bind(this))
        : requestAnimationFrame(this.reveal.bind(this));
    }

    hide() {
      if (this.classList.contains(this.formActiveClassName)) {
        this.classList.remove(this.formActiveClassName);
        this.classList.add(this.formInactiveClassName);
      }
    }

    reveal() {
      if (this.classList.contains(this.formInactiveClassName)) {
        this.classList.add(this.formActiveClassName);
        this.classList.remove(this.formInactiveClassName);
      }
    }

    addAdditionalSpace() {
      const stickyFormDimensions = this.getBoundingClientRect()

      // Add space at the bottom of the page for the form
      this.documentBody.style.paddingBottom = stickyFormDimensions.height + 'px'
    }
  }
);

const quantityInputs = document.querySelectorAll('.quantity__input');

quantityInputs.forEach((input) => {
  input.addEventListener('change', function () {
    quantityInputs.forEach((input) => {
      input.value = this.value;
    });
  });
});
